import { createContext, Dispatch } from "react";
import type { State, setLayoutAction } from "./types/Layout";

// Define the context shape
interface LayoutContextType {
  state: State;
  dispatch: Dispatch<setLayoutAction>; // Use a more specific action type if available
}
const defaultContextValue: LayoutContextType = {
  state: {}, // Provide a default or initial state
  // eslint-disable-next-line
  dispatch: () => {}, // Dummy dispatch function, or implement a more meaningful default
};
// Create the context with an undefined default value
export const LayoutContext = createContext<LayoutContextType | undefined>(defaultContextValue);
